// import { Permission } from './lib/Permission';
import { Permission2 } from './lib/Permission2';

export * from './lib/components';
export * from './lib/hooks';
// export default Permission;
export default Permission2;
